import domContentLoaded from "dom-content-loaded";

domContentLoaded(() => {
  // メインビジュアル
  const $slider_mv = $(".js-slider");
  $slider_mv.slick({
    accessibility: true,
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prevbtn"></button>',
    nextArrow: '<button type="button" class="slick-nextbtn"></button>',
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "380px",
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          centerPadding: "300px",
        },
      },
      {
        breakpoint: 1023,
        settings: {
          centerPadding: "200px",
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          centerPadding: "10%",
        },
      },
    ],
  });

  // 事例のスライダー
  const $topWorksSlider = $(".js-topworksslider");
  $topWorksSlider.slick({
    accessibility: true,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prevbtn"></button>',
    nextArrow: '<button type="button" class="slick-nextbtn"></button>',
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    centerMode: true,
    slidesToShow: 3,
    centerPadding: "10%",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          // arrows: false,
          centerPadding: "10%",
        },
      },
    ],
  });

  $slider_mv.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
    $slider_mv.find(".slick-slide").each((index, el) => {
      const $this = $(el),
        slickindex = $this.attr("data-slick-index");
      if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
        if (slickindex == "-1") {
          $this.addClass("is-active-next");
        } else {
          $this.removeClass("is-active-next");
        }
      } else if (nextSlide == 0) {
        if (slickindex == slick.slideCount) {
          $this.addClass("is-active-next");
        } else {
          $this.removeClass("is-active-next");
        }
      } else {
        $this.removeClass("is-active-next");
      }
    });
  });
});

// 重要なお知らせ
const $important_infoslider = $(".js-important_info");
$important_infoslider.slick({
  vertical: true,
  accessibility: true,
  dots: false,
  arrows: true,
  // prevArrow: '<button type="button" class="slick-prevbtn"></button>',
  // nextArrow: '<button type="button" class="slick-nextbtn"></button>',
  autoplay: true,
  autoplaySpeed: 2500,
  pauseOnHover: true,
  // centerMode: true,
  // slidesToShow: 1,
  // centerPadding: '500px',
});
